/* eslint-disable @typescript-eslint/naming-convention */
export enum LanguageCodes {
  'fr' = 'fr-FR',
  'en' = 'en-US',
}

export type LanguageRoute = 'fr' | 'en'
